import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "@emotion/styled";
import { resend } from "./thunk";
import { FaCheck } from "react-icons/fa";
import { IoIosArrowBack } from "react-icons/io";
import { flowGo } from "./action";
import { selectedPhone } from "./selector";
import DefaultOrangeButton from "@modules/Components/DefaultOrangeButton";
import { useHistory } from "react-router-dom";

const ResendSuccess = styled.span`
  color: #39c876;
  font-size: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
`;

const Header = styled.div`
  font-size: 30px;
  font-weight: 500;
  text-align: center;
  color: #1f2021;
`;

const EnterCodeHeader = styled(Header)`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  @media (max-width: 375px) {
    font-size: 27px;
  }
  @media (max-width: 330px) {
    font-size: 24px;
  }
  @media (max-width: 300px) {
    font-size: 22px;
  }
`;

const BackArrow = styled(IoIosArrowBack)`
  color: rgba(119, 121, 132, 0.5);
  position: absolute;
  font-size: 30px;
  left: 0;
  cursor: pointer;

  @media (max-width: 375px) {
    font-size: 27px;
  }
  @media (max-width: 330px) {
    font-size: 24px;
  }
  @media (max-width: 300px) {
    font-size: 22px;
  }
`;

const Text = styled.div`
  font-size: 16px;
  line-height: 1.75;
  text-align: center;
  color: #777984;
  max-width: 455px;
  margin: 0 auto;
  padding-top: 18px;
  padding-bottom: 35px;

  @media (max-width: 525px) {
    font-size: 15px;
  }
`;

const ResendCode = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 36px;
`;

const Resend = styled.span`
  cursor: pointer;
  font-size: 16px;
  text-align: center;
  color: #1f2021;
`;

const ResendVerification = ({ type, orderUUID }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const phoneType = useSelector(state => state.orderVerification.phoneType);
  const theSelectedPhone = useSelector(state => selectedPhone(state));
  const [resendText, changeResendText] = useState("Resend code");

  const handleResendCode = () => {
    const response = dispatch(resend(type, orderUUID));
    if (response) {
      changeResendText(
        <ResendSuccess>
          <FaCheck
            style={{
              marginRight: "5px",
              fontSize: "16px"
            }}
          />
          Code resent
        </ResendSuccess>
      );
    }
  };

  return (
    <div className="enter-code-verify">
      <EnterCodeHeader>
        <BackArrow onClick={() => dispatch(flowGo("select-phone"))} />
        Thank you
      </EnterCodeHeader>
      <Text>
        A
        {phoneType === "sms"
          ? ` text message has been sent to ${theSelectedPhone.maskedPhone}`
          : ` phone call has been queued to ${theSelectedPhone.maskedPhone}`}
        . Please complete the phone verification by responding to the prompts.
        The order will be processed once the verification is completed. If the
        order is not verified within 12 hours, it will be cancelled.
      </Text>

      <ResendCode>
        <Resend onClick={handleResendCode}>{resendText}</Resend>
      </ResendCode>

      <DefaultOrangeButton
        handleClick={() => {
          history.push("/");
        }}
        classes={"main-default-orange-button"}
      >
        <span>Done</span>
      </DefaultOrangeButton>
    </div>
  );
};

export default ResendVerification;
